import React, { useMemo } from 'react';

import { useUserDetailsContext } from 'context/userDetailsContext';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

import ViewChanger from './ViewChanger';
import constants from 'constants/index';
import Discrepancy from './Discrepancy';
import CreateTimeline from './CreateTimeline';
import CreateDocument from './CreateDocument';
import ExtractEntities from './ExtractEntities';
import UploadFileButton from './UploadFileButton';
import CreateFolderButton from './CreateFolderButton';
import DownloadCaseButton from './DownloadCaseButton';

function Menu() {
  const { getPermission, checkSubPermission } = useUserDetailsContext();
  const { isGlobalFileManager, isCaseFileManager, isLeadFileManager, isClientFileManager, isFirmDocuments, breadCrumbs } =
    useFileManagerContext();

  const canWrite = getPermission('cases') === constants.permissions.WRITE;
  const showDiscrepancy = checkSubPermission('ai_find_discrepancies') && (isCaseFileManager || isLeadFileManager);
  const showCreateDocument = checkSubPermission('document_assembly') && !isGlobalFileManager && !isClientFileManager;
  const showCreateFolder = isFirmDocuments || (!isGlobalFileManager && !isClientFileManager);
  const showUpload = isCaseFileManager || isClientFileManager || isLeadFileManager;
  const showExtractEntities = checkSubPermission('ai_extract_entities') && !isGlobalFileManager && !isClientFileManager;
  const showTimeline = checkSubPermission('ai_create_timeline') && !isGlobalFileManager && !isClientFileManager;
  const showDownloadCase = isCaseFileManager || isLeadFileManager;

  const isVirtualFolder = useMemo(() => breadCrumbs?.some((file) => file?.is_virtual === true), [breadCrumbs]);

  return (
    <>
      {/* Line 1: ViewChanger, Discrepancy, Create Document */}
      <div className="menu-row menu-row-top d-flex gap-2">
        <ViewChanger />
        {showDiscrepancy ? <Discrepancy /> : null}
        {showCreateDocument && <CreateDocument />}
      </div>

      {/* Line 2: Create Folder and Upload File */}
      {(canWrite || isClientFileManager) && !isVirtualFolder && (
        <div className="menu-row menu-row-middle d-flex gap-2">
          {showCreateFolder && <CreateFolderButton />}
          {showUpload && <UploadFileButton />}
          {showDownloadCase && <DownloadCaseButton />}
        </div>
      )}

      {/* Line 3: Extract Entities and Create Timeline */}
      <div className="menu-row menu-row-bottom d-flex gap-2">
        {showExtractEntities && <ExtractEntities />}
        {showTimeline && <CreateTimeline />}
      </div>
    </>
  );
}

export default Menu;
